import React from "react";
import type { ComponentType } from "react";
import { Ban, CheckCircle2, Filter, Move } from "lucide-react";
import type { StoryTrailAction } from "../../services/storyCanvas/storyFilterChips.types";
import { SizedDrillGlyph } from "./storyTrailActionIcons.styles";

export interface StoryTrailActionIconProps {
  size?: number;
  "aria-hidden"?: boolean;
}

const DEFAULT_SIZE = 16;

const DrillIcon: React.FC<StoryTrailActionIconProps> = ({ size = DEFAULT_SIZE }) => (
  <SizedDrillGlyph $size={size} aria-hidden data-testid="story-trail-drill-icon" />
);

/**
 * One icon per trail action, so a step reads the same wherever it shows (the point popover, the
 * filter panel's chips, the trail). Swap a glyph here and every consumer follows.
 */
export const storyTrailActionIcons: Record<StoryTrailAction, ComponentType<StoryTrailActionIconProps>> = {
  filter: Filter,
  cross: Move,
  keep: CheckCircle2,
  remove: Ban,
  drill: DrillIcon,
};
